import React, { useState, useEffect } from "react";
import { ImageIcon, useQwanyx } from "qwanyx";
import "bulma/css/bulma.min.css";
import 'animate.css'; // Import Animate.css

export const ImageIconGrid = ({
  icons = [],
  style = {},
  ratio = "1/1",
  imageWidth = "64px",
  columnsPerRow = 3,
  imageClassName = "",
  textStyle = {},
  textClassName = "",
  displayIcons = null, // Number of icons to display (null = all)
  random = false,      // Whether to randomly select icons
  interval = null,     // Interval for continuous randomization (ms)
  animateClass = "",   // New prop for Animate.css class names (can be without animate__animated prefix)
}) => {
  const { updateSelectedCard } = useQwanyx();
  const [displayedIcons, setDisplayedIcons] = useState([]);

  // Function to shuffle array (Fisher-Yates algorithm)
  const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };

  // Function to get the icons to display
  const getIconsToDisplay = () => {
    if (!displayIcons || displayIcons >= icons.length) {
      return random ? shuffleArray(icons) : icons;
    }

    if (random) {
      const shuffled = shuffleArray(icons);
      return shuffled.slice(0, displayIcons);
    }

    return icons.slice(0, displayIcons);
  };

  // Set initial icons
  useEffect(() => {
    setDisplayedIcons(getIconsToDisplay());
  }, [icons, displayIcons, random]);

  // Set up interval for continuous randomization if interval is provided
  useEffect(() => {
    if (interval && random) {
      const timer = setInterval(() => {
        // Simply update icons - animation is handled by CSS classes
        setDisplayedIcons(getIconsToDisplay());
      }, interval);

      return () => clearInterval(timer);
    }
  }, [interval, random, icons, displayIcons]);

  const handleClick = (iconTarget) => {
    if (!iconTarget) return;

    // Force a new object reference with added timestamp
    const cardData = {
      _id: iconTarget._id,
      di: iconTarget.di,
      ed: iconTarget.ed,
      pa: iconTarget.pa,
      // Add a timestamp to force re-render even if same card is clicked
      _timestamp: Date.now()
    };

    console.log("Updating card with:", cardData);
    updateSelectedCard(cardData);
  };

  // Combine animation classes with existing classes
  const getAnimationClasses = (baseClass) => {
    if (!animateClass) {
      return baseClass;
    }

    // Add base animation class if not already included
    const animationClasses = animateClass.includes('animate__animated')
      ? animateClass
      : `animate__animated ${animateClass}`;

    return baseClass ? `${baseClass} ${animationClasses}` : animationClasses;
  };

  return (
    <div className="container" style={style}>
      <div className="columns is-multiline is-mobile">
        {displayedIcons.map((icon, index) => (
          <div
            key={`${index}-${icon.url}`}
            className={`column is-${12 / columnsPerRow}`}
          >
            <div
              onClick={() => handleClick(icon.target)}
              style={{ cursor: "pointer" }}
            >
              <div className={getAnimationClasses("animate__animated")}>
                <ImageIcon
                  ratio={ratio}
                  imageUrl={icon.url}
                  text={icon.text}
                  textStyle={textStyle}
                  textClassName={textClassName}
                  imageWidth={imageWidth}
                  containerStyle={{ width: "100%" }}
                  imageClassName={imageClassName}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageIconGrid;